// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__NtaVb","topBottomGutter":"Layout_topBottomGutter__T5dAd"};